<template lang="pug">
table.loading-table
  thead
    tr
      th(
        v-for="col in columns"
        :key="col"
      )
  AppTableLoadingBody(
    :columns="columns"
    :rows="rows"
  )
</template>

<script>
import AppTableLoadingBody from '~/components/AppTableLoadingBody.vue';

export default {
  name: 'AppTableLoading',
  components: { AppTableLoadingBody },
  props: {
    columns: {
      type: Number,
      default: 2,
    },
    rows: {
      type: Number,
      default: 4,
    },
  },
};
</script>
